module.exports = __webpack_public_path__ + "coin_XEM.png?e08c65d8aed964d1e630f42e5c15ae5b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_XEM.png
// module id = 1115
// module chunks = 2